import axios from 'axios'
import {handleError} from '../handleError'
import {LError} from '../../object'
const state = {
  classRefresh: false,
  labelRefresh: false,
  templateRefresh: false,
  eventRefresh: false,
  notificationList: []
}
const mutations = {
  setClassRefresh (state, data) {
    state.classRefresh = data
  },
  setLabelRefresh (state, data) {
    state.labelRefresh = data
  },
  setTemplateRefresh (state, data) {
    state.templateRefresh = data
  },
  setEventRefresh (state, data) {
    state.eventRefresh = data
  },
  setNotificationList (state, data) {
    state.notificationList = data
  }
}
const getters = {}
const actions = {
  async register () {
    let url = '/iotApi/fs/iot/register'
    let params = {
      "deviceId":"ctrl01",
      "subDeviceId":["01","02"]
    }
    try {
      let res = await axios.post(url, params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async sendMsg ({dispatch}, params) {
    let url = '/iotApi/fs/iot/alertChannel/to?sn=01'
    try {
      let res = await axios.post(url, params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 获取列表通用函数 */
  async getList ({dispatch}, {pagination, sortStack, search, filter, url}) {
    let {items, amount} = await dispatch('getDataList', {
      url: url,
      pagination,
      sortStack,
      search,
      filter: filter || {}
    }, {root: true})
    return {
      items,
      amount
    }
  },
  /* 添加通用函数 */
  async addActions ({dispatch}, {params, url}) {
    try {
      let res = await axios.post(url, params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 删除通用函数 */
  async deleteActions ({dispatch}, {params, url}) {
    try {
      let res = await axios.delete(url, {data: params})
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async sendMsgByTemplate ({dispatch}, params) {
    let url = '/messageApi/msgSending'
    try {
      let res = await axios.post(url, params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  async sendMsgByEvent ({dispatch}, params) {
    let url = '/messageApi/msgEventSending'
    try {
      let res = await axios.post(url, params)
      return res
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 拉取未读公告 */
  async getUnreadNotifications ({dispatch}, userId) {
    let url = '/messageApi/getUnreadAnnounce?userId=' + userId + '&institutionId=smaco'
    try {
      let res = await axios.get(url)
      console.log(res)
      if (res.data.code + '' === '200') {
        dispatch('getUnreadNotificationList', userId)
      }
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  },
  /* 获取未读公告列表 */
  async getUnreadNotificationList ({dispatch, commit}, userId) {
    let url = '/messageApi/getUnreadAnnounceNum?userId=' + userId + '&institutionId=smaco'
    try {
      let res = await axios.get(url)
      console.log(res)
      if (res.data.code + '' === '200') {
        commit('setNotificationList', res.data.data.announces)
      }
    }
    catch (e) {
      if (e instanceof Promise) {
        let err = await e
        throw handleError(err)
      }
      else {
        throw handleError(e)
      }
    }
  }
}
export default{
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
